export default {
    option: ['全部', '同期活动', '展商直播'],
    status: {
        '1': '待直播',
        '2': '直播中',
        '3': '回放'
    },
    startTime: '开播时间',
    looker: '在看',
    toLive: '进入直播',
    taggleLiveStatus: ['直播', '回放', '待开始'],
    recommentLive: '推荐',
    hotLive: '人气',
    more: '更多',
    miss:"人想看",
    exchangeCards: "交换名片",
    success:"成功",
    successTips:"交换名片申请已经发送",
    noData:"暂无数据",
    liveDescribe:'直播简介',
    'Live Management':'直播管理',
    sendDanMuTip:'和主播互动吧',
    send:'发送',
    sendTextTip:'请输入发送的内容'
}